import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MySafeHtml } from './safe-html.pipe';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
	],
	exports: [
		MySafeHtml
	],
	declarations: [
		MySafeHtml,
	],
})
export class SafeHtmlModule {
	public static forRoot() {
		return {
			ngModule: SafeHtmlModule,
			providers: []
		};
	}
}

export { MySafeHtml };
